import React from 'react'
import { styled } from '@mui/material/styles'

const HighlightedSpan = styled('span')(() => ({
  backgroundColor: '#FFD54F',
  fontWeight: 'bold',
}))

/**
 * Highlights matches of a query string within a text string.
 * @param text The text to search in.
 * @param query The query string to highlight.
 */
export const highlightText = (text: string, query: string): React.ReactNode => {
  if (!query || !text) {
    return text
  }

  const parts = text.split(new RegExp(`(${query})`, 'gi'))

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <HighlightedSpan key={`${part}-${index}`}>{part}</HighlightedSpan>
        ) : (
          part
        ),
      )}
    </>
  )
}
